import React from 'react';
import Slider from 'react-slick';
import { FaExternalLinkAlt } from 'react-icons/fa';
import './BlogCarousel.css';

const BlogCarousel = () => {
  const blogPosts = [
    {
      title: 'Mastering Core Concepts of Object-Oriented Programming',
      readTime: '5 min read',
      date: 'May 20, 2025',
      link: 'https://medium.com/@neginikhilsingh6/mastering-core-concepts-of-object-oriented-programming-42d67b3ed00b',
      image: 'https://media.istockphoto.com/id/1290154699/vector/comic-speech-bubble-with-text-oops-message-in-pop-art-style.jpg?s=612x612&w=0&k=20&c=4J-vEqvSWx-HEq8IiG5qP1WcM4Sf1xNsmXNInjMzWHY='
    },
    {
      title: 'Teaching AI Models to Use Their "Gut Feeling"',
      readTime: '7 min read',
      date: 'April 15, 2025',
      link: 'https://freedium.cfd/https://medium.com/@ignacio.de.gregorio.noblejas/teaching-ai-models-to-use-their-gut-feeling-0bc5a6fb4055',
      image: 'https://img.etimg.com/thumb/msid-77198656,width-640,resizemode-4/tech/ites/the-rise-of-machines-timeline-of-the-evolution-of-artificial-intelligence/first-what-is-the-big-fuss-really.jpg'
    },
    {
      title: 'MySQL Basics to Advance',
      readTime: '6 min read',
      date: 'September 9, 2024',
      link: 'https://www.linkedin.com/pulse/mysql-basics-advance-nikhil-negi-hqahc/?trackingId=1kHqPYyHSkCbKsmwLh8NrA%3D%3D',
      image: 'https://www.mytecbits.com/wp-content/uploads/SQL.png'
    }
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } }
    ]
  };

  return (
    <div className="blog-carousel">
      <Slider {...settings}>
        {blogPosts.map((post, index) => (
          <div key={index} className="blog-slide">
            <div className="blog-card">
              <div className="blog-image">
                <img src={post.image} alt={post.title} />
              </div>
              <div className="blog-content">
                <span className="blog-date">{post.date} · {post.readTime}</span>
                <h3>{post.title}</h3>
                <a 
                  href={post.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="blog-link"
                >
                  <FaExternalLinkAlt /> Read on Medium
                </a>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BlogCarousel;
